<template>
  <div class="wrapper">
    <div class="actBar">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="examId" size="small" placeholder="搜索考试名称">
            <el-option
              v-for="item in examList"
              :key="item.id"
              :label="item.examName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="getData"
            >查询</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="print()"
            v-if="canPrint"
            >打印</el-button
          >
          <el-button type="primary" size="small" @click="downloadModel"
            >下载导入模板</el-button
          >&ensp;
          <el-button
            type="primary"
            size="small"
            @click="downloadMultiSelectModel"
            >下载多选题选项导入模板</el-button
          >&ensp;
          <el-upload
            style="display: inline-block"
            action="/base/common/importExamQuestionAnalysisExcel"
            :headers="{ Authorization: getStore('accessToken') }"
            :show-file-list="false"
            :on-success="importSuccess"
            ><el-button type="primary" size="small">导入成绩单 </el-button>
          </el-upload>
          &ensp;
          <el-upload
            style="display: inline-block"
            action="/base/common/importMultipleSelection"
            :headers="{ Authorization: getStore('accessToken') }"
            :show-file-list="false"
            :on-success="importMultiSelectSuccess"
            ><el-button type="primary" size="small">导入多选题选项 </el-button>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <div
      id="printContainer"
      class="printContainer"
      style="width: 794px; margin: auto"
    >
      <div
        class="questionContainer"
        v-for="questionType in questionTypeList"
        :key="'questionType' + questionType.type"
        style="font-size: 16px; line-height: 24px"
      >
        <h3 style="border: 1px solid #ccc; padding: 10px; margin: 0">
          {{ questionType.type }}
        </h3>
        <div
          class="questionListSplit"
          v-for="(block, blockIdx) in questionType.questionBlockList"
          :key="'questionBlock' + blockIdx"
          style="
            border-left: 1px solid #ccc;
            border-right: 1px solid #ccc;
            margin-bottom: 20px;
            page-break-after: always;
          "
          :style="{ borderTop: blockIdx ? '1px solid #ccc' : 'none' }"
        >
          <div
            class="questionCell"
            v-for="(question, questionIdx) in block"
            :key="'question' + questionIdx"
            style="border-bottom: 1px solid #ccc; padding: 10px"
          >
            <div class="questionTitle" style="margin-bottom: 5px">
              {{ question.no }}、{{ question.questionName }}
            </div>
            <div class="answer" v-for="answer in question.itemList">
              {{ answer.index }}、{{ answer.question }} &ensp;
              <span style="color: #f56c6c"> {{ answer.answerRate }} </span>
            </div>

            <div class="consult" style="margin-top: 5px">
              答案：{{ question.answerTrue }} &emsp;分数：{{
                question.score
              }}&emsp;分类：{{ question.classification }}&emsp; 满分率：
              <span
                style="
                  background: #ddd;
                  display: inline-block;
                  padding: 0 5px;
                  margin: 0;
                "
                >{{ question.scoreRate }}</span
              >
            </div>
            <div
              class="selectShowContainer"
              v-if="
                questionType.type == '多选题' ||
                questionType.type == '不定项选择题'
              "
              style="
                display: flex;
                flex-wrap: wrap;
                border-top: 1px solid #ccc;
                border-left: 1px solid #ccc;
                margin-top: 10px;
              "
            >
              <div
                class="selectCell"
                style="width: 33.3%; display: flex; text-align: center"
                v-for="(select, selectidx) in question.multipleChoiceList"
                :key="'select' + selectidx"
              >
                <div
                  class="selectKey"
                  style="
                    flex: 1;
                    border-right: 1px solid #ccc;
                    border-bottom: 1px solid #ccc;
                  "
                >
                  {{ select.name }}
                </div>
                <div
                  class="selectValue"
                  style="
                    flex: 1;
                    border-right: 1px solid #ccc;
                    border-bottom: 1px solid #ccc;
                  "
                >
                  {{ select.value }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { examQuestionAnalysis } from "@/api/paper.js";
import { getExamList } from "@/api/index.js";
export default {
  data() {
    return {
      examId: "",
      questionTypeList: [],
      canPrint: false,
      examList: [],
    };
  },
  created() {},
  mounted() {
    console.log(this.examId);

    getExamList().then((data) => {
      this.examList = data.data;
    });
  },
  methods: {
    print() {
      setTimeout(() => {
        var oldstr = document.body.innerHTML;
        var headStr = "<html><head><title></title></head><body>";
        var footStr = "</body>";
        var content = document.getElementById("printContainer").innerHTML;
        var newStr = headStr + content + footStr;
        document.body.style.overflow = "auto";
        // document.body.innerHTML = content;
        let myWindow = window.open();
        myWindow.document.write(content);
        myWindow.print();
        // setTimeout(() => {
        //   window.print();
        //   document.body.innerHTML = oldstr;
        // }, 200);

        //
      }, 1000);
    },
    questionDivided() {
      //   一页36行 一行34字
      let fontLimit = 42,
        questionCount = 1,
        lineCount = 0,
        lineLimit = 42;
      this.questionTypeList.forEach((type) => {
        lineCount = 0;
        let questionBlockList = [[]],
          questionBlockCount = 0;
        if (type.type == "多选题") {
          console.log("找到多选题");
        }
        type.value.forEach((question) => {
          let currentLine =
            parseInt(question.questionName.length / fontLimit) + 3; //答案一行，行间距一行
          if (question.multipleChoiceList) {
            //多选题选项计算
            question.multipleChoiceList = JSON.parse(
              question.multipleChoiceList
            );
            currentLine =
              currentLine +
              parseInt(question.multipleChoiceList.length / 3) + //多选题
              (question.multipleChoiceList.length % 3 == 0 ? 1 : 2);
          }
          question.itemList.forEach((answer) => {
            currentLine =
              parseInt(answer.question.length / fontLimit) + 1 + currentLine;
          });
          if (currentLine + lineCount < lineLimit) {
            lineCount = currentLine + lineCount;
            questionBlockList[questionBlockCount].push(question);
          } else {
            lineCount = currentLine;
            questionBlockCount++;
            questionBlockList.push([question]);
          }
          question.no = questionCount;
          questionCount++;
        });
        type.questionBlockList = questionBlockList;
      });
      this.canPrint = true;
    },
    getData() {
      this.canPrint = false;
      examQuestionAnalysis({ examinationId: this.examId }).then((data) => {
        this.questionTypeList = data.data;
        this.questionDivided();
      });
    },
    downloadModel() {
      location.href = "../试题分析模板.xlsx";
    },
    downloadMultiSelectModel() {
      location.href = "../多选题答案模板.xlsx";
    },
    importSuccess(data) {
      this.$alert(data.info);
      console.log(data);
    },
    importMultiSelectSuccess(data) {
      this.$alert(data.info);
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  .actBar {
    width: 794px;
    margin: auto;
  }
}
</style>
